import { render, staticRenderFns } from "./UserListForm.vue?vue&type=template&id=719604ce"
import script from "./UserListForm.vue?vue&type=script&lang=js"
export * from "./UserListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports